// DIAN check-digit weights, applied to the base digits from right to left.
const NIT_WEIGHTS = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];

/**
 * Keeps only the digits of a Colombian NIT, at most 11 (9-10 base digits + check digit).
 */
export const cleanNit = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, "").slice(0, 11);
};

/**
 * Formats a NIT as "{base}-{check digit}" (e.g. "890903938-8"), suitable
 * while the user types.
 */
export const formatNit = (value: string): string => {
  const digits = cleanNit(value);
  if (digits.length <= 1) return digits;
  const base = digits.slice(0, -1);
  const dv = digits.slice(-1);
  return `${base}-${dv}`;
};

const nitCheckDigit = (base: string): number => {
  const total = base
    .split("")
    .reverse()
    .reduce((acc, digit, index) => acc + Number(digit) * NIT_WEIGHTS[index], 0);
  const remainder = total % 11;

  if (remainder === 0 || remainder === 1) return remainder;
  return 11 - remainder;
};

/**
 * Validates a Colombian NIT (9-10 base digits + check digit).
 */
export const checkNit = (nit: string): boolean => {
  if (!nit) return false;

  const digits = cleanNit(nit);
  if (digits.length < 10) return false;

  const base = digits.slice(0, -1);
  const dv = Number(digits.slice(-1));
  return nitCheckDigit(base) === dv;
};
